/*
 * Image Compare — comparador de imágenes para el tema Circuit.
 * Réplica funcional del bloque "Comparison slider" de Horizon, sin dependencias.
 */
(function () {
  if (customElements.get('image-compare-slider')) return;

  class ImageCompareSlider extends HTMLElement {
    connectedCallback() {
      // El elemento puede actualizarse durante el parseo del HTML, antes de que
      // sus hijos existan. Se difiere la inicialización hasta que estén listos.
      if (this.querySelector('[data-image-compare-range]')) {
        this.init();
      } else if (document.readyState === 'loading') {
        this._onReady = this.init.bind(this);
        document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
      } else {
        var self = this;
        requestAnimationFrame(function () {
          self.init();
        });
      }
    }

    init() {
      if (this.initialized) return;

      this.media = this.querySelector('[data-image-compare]');
      this.range = this.querySelector('[data-image-compare-range]');
      if (!this.media || !this.range) return;

      this.initialized = true;
      this.orientation = this.media.dataset.orientation || 'horizontal';
      this.hasAnimated = false;
      this.isAnimating = false;
      this.timers = [];

      this.sync = this.sync.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);

      this.range.addEventListener('input', this.sync);
      this.range.addEventListener('change', this.sync);
      this.range.addEventListener('pointerdown', this.sync);

      this.sync();
      this.setupIntersectionObserver();
    }

    disconnectedCallback() {
      if (this._onReady) document.removeEventListener('DOMContentLoaded', this._onReady);
      if (this.range) {
        this.range.removeEventListener('input', this.sync);
        this.range.removeEventListener('change', this.sync);
        this.range.removeEventListener('pointerdown', this.sync);
      }
      if (this.observer) this.observer.disconnect();
      (this.timers || []).forEach(clearTimeout);
      this.timers = [];
      this.initialized = false;
    }

    /* Sincroniza el valor del input con la variable CSS --compare */
    sync() {
      if (this.isAnimating || !this.range) return;
      var min = Number(this.range.min);
      var max = Number(this.range.max);
      var val = (Number(this.range.value) - min) / (max - min);
      this.media.style.setProperty('--compare', String(Math.round(val * 100)));
    }

    setValue(value) {
      if (!this.range) return;
      this.range.value = String(value);
      this.sync();
    }

    /* Animación de entrada: pista visual de que el control se arrastra */
    animateSlider() {
      if (this.hasAnimated) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.hasAnimated = true;
      this.isAnimating = true;
      this.media.style.setProperty('--ic-transition', '0.5s');

      var self = this;
      var step = function (delay, value) {
        self.timers.push(
          setTimeout(function () {
            self.media.style.setProperty('--compare', value);
          }, delay)
        );
      };

      step(100, '40');
      step(600, '60');
      step(1100, '50');

      this.timers.push(
        setTimeout(function () {
          self.media.style.setProperty('--ic-transition', '0s');
          self.range.value = '50';
          self.isAnimating = false;
        }, 1600)
      );
    }

    setupIntersectionObserver() {
      if (!window.IntersectionObserver) return;

      this.observer = new IntersectionObserver(this.handleIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      });
      this.observer.observe(this);
    }

    handleIntersection(entries) {
      var self = this;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || self.hasAnimated) return;

        self.timers.push(
          setTimeout(function () {
            self.oncePerEditorSession('image-compare-animated', function () {
              self.animateSlider();
            });
          }, 300)
        );

        if (self.observer) self.observer.disconnect();
      });
    }

    /* En el editor de temas, evita repetir la animación en cada re-render */
    oncePerEditorSession(key, callback) {
      var inEditor = typeof window.Shopify !== 'undefined' && window.Shopify.designMode;
      if (!inEditor) return callback();

      var storageKey = key + ':' + (this.dataset.sectionId || '');
      try {
        if (window.sessionStorage.getItem(storageKey)) return;
        window.sessionStorage.setItem(storageKey, '1');
      } catch (e) {}
      callback();
    }
  }

  customElements.define('image-compare-slider', ImageCompareSlider);
})();
